import { ref } from 'vue'

const chatOpen = ref(false)

export function useGleanChat() {
  const agentId = import.meta.env.VITE_GLEAN_AGENT_ID
  const gleanApiUrl = import.meta.env.VITE_GLEAN_API_URL

  const isEnabled = import.meta.env.VITE_GLEAN_ENABLED === 'true' && !!gleanApiUrl

  function toggleChat() {
    chatOpen.value = !chatOpen.value
  }

  return { chatOpen, isEnabled, toggleChat, gleanApiUrl, agentId }
}
